import { baseFetch } from '../../baseFetch';
import { ExitStatusResponseSchema } from '../../schemas/ExitStatusResponseSchema';
import {
  UpdateOrderResponseSchema,
  UpdateShowDeltaTResponseSchema,
} from './orders.schema';

export const updateOrderShowDeltaT = (
  orderId: number,
  deltaTVisible: boolean,
) => {
  return baseFetch(
    'internal-v2',
    `/solar_orders/${orderId}/show_delta_t`,
    UpdateShowDeltaTResponseSchema.defined(),
    {
      method: 'PATCH',
      requestBody: {
        show_delta_t: deltaTVisible,
      },
    },
  );
};

export interface OrderUpdate {
  org_id: number;
  order_type: string;
  solar_farm_uuid: string;
  uuid: string;
  priority: number;
  delivered_tsecs?: number | null;
  contract_type?: string | null;
  requested_delivery_date?: number | null;
  turnkey_services?: boolean | null;
  requested_flight_date?: number | null;
  site_contact_uuid?: string | null;
  pilot_contact_uuid?: string | null;
  estimated_delivery_date?: number | null;
  estimated_flight_date?: number | null;
  data_collection_status?: number | null;
  email_updates_enabled?: boolean | null;
  flight_start_date?: number | null;
  flight_end_date?: number | null;
  updator_id?: number | null;
  channel_orgs?: Array<{ id: number }> | null;
  client_orgs?: Array<{ id: number }> | null;
  client_org_id?: number | null;
  substatus?: number | null;
  claimed_by_user_id?: number | null;
  comments_to_channel?: string | null;
  comments_from_channel?: string | null;
  special_instructions?: string | null;
  internal_comments?: string | null;
  processing_hold?: boolean | null;
  data_received_tsecs?: number | null;
  source_order_uuid?: string | null;
  data_collection_org_id?: number | null;
  accounting_invoice_number?: string | null;
  pm_user_id?: number | null;
  mailing_list?: string | string[] | null;
  sales_project_id?: number | null;
  data_collection_manager_id?: number | null;
  id_report_provider?: number | null;
  image_skip_rate?: number | null;
}

export const updateOrder = (orderId: number, updates: OrderUpdate) => {
  return baseFetch(
    'internal-v2',
    `/solar_orders/${orderId}`,
    UpdateOrderResponseSchema.defined(),
    {
      method: 'PUT',
      requestBody: updates,
    },
  );
};

export const updateOrderStatus = (orderUuid: string, newStatus: number) => {
  return baseFetch(
    'internal-v2',
    `/solar_orders/${orderUuid}/status`,
    ExitStatusResponseSchema.defined(),
    {
      method: 'PUT',
      requestBody: { status: newStatus },
    },
  );
};
